import { render, staticRenderFns } from "./SavitzkyGolay.vue?vue&type=template&id=b21b91bc&"
import script from "./SavitzkyGolay.vue?vue&type=script&lang=js&"
export * from "./SavitzkyGolay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports